<template>
  <div
    v-if="type == UserType.FRONT || type == UserType.MARKETPLACE || type == 1 || origin === 1"
    :class="`customer-verify design-${design}`"
    v-bind:title="title"
  >
    <i class="fal fa-mobile-android"></i>
  </div>
</template>
<script>
import { Type as UserType } from "easyjs/lib/Schema/Account/User";

export default {
  props: {
    design: { type: String, default: "one" },
    type: { type: String, default: UserType.LOCAL },
    origin: { type: Number },
    title: { type: String },
  },
  data() {
    return { UserType };
  },
};
</script>
<style scoped>
  .customer-verify {
    position: absolute;
    top: 16px;
    right: 19.5px;
    padding: 5px 10px;
    font-size: 17px;
    border-radius: 5px;
  }

  .design-one {
    background: #695F56;
    color: white;
  }
</style>
